<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>Cadastro de Profissionais</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="profissional.id"
                      label="Código"
                      v-bind:disabled="true"
                    ></v-text-field>
                  </v-flex>

                  <!-- LINHA 1, CAMPO NOME DO ASSOCIADO -->
                  <!-- LINHA 1, CAMPO NOME DO ASSOCIADO -->
                  <v-flex xs12 sm5>
                    <v-text-field
                      type="tel"
                      v-model="profissional.cpf"
                      label="CPF"
                      v-mask="'###.###.###-##'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <!-- LINHA 3, CAMPO Dt Nascimento -->
                  <v-flex xs12 sm3>
                    <v-text-field
                      v-model="profissional.nascimento"
                      label="Data de nascimento"
                      type="tel"
                      v-mask="'##/##/####'"
                      required
                      @input="onDataSelect()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-switch
                      label="Ativo"
                      v-model="profissional.ativo"
                      false-value="N"
                      true-value="S"
                    ></v-switch>
                  </v-flex>
                  <!-- LINHA 1, CAMPO NOME DO ASSOCIADO -->
                  <v-flex xs12 sm10>
                    <v-text-field v-model="profissional.nome" label="Nome" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <v-text-field v-model="profissional.endereco" label="Endereço" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="profissional.numero" label="Número" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="profissional.bairro" label="Bairro" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                     <e-select-cidade v-model="profissional.fk_cidade" :localidade="profissional.localidade" :uf="profissional.uf" @userSelect="onSelectCidade"/>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="profissional.cep"
                      label="CEP"
                      type="tel"
                      v-mask="'#####-###'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field v-model="profissional.uf" label="UF" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                      type="tel"
                      v-model="profissional.celular"
                      label="Celular"
                      v-mask="'##-#####-####'"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                      type="tel"
                      v-model="profissional.fixo"
                      label="Fixo"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-currency-field v-model="profissional.comissao" v-bind="currency_config" label="Comissão"></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field v-model="profissional.codigo_integracao" label="Código integração" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/profissionais')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="imprimirCartao()">Imprimir cartão</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { formatDateToBr, showFlash, showError, validateDate } from '@/utils'
import profissionalService from '@/services/profissional'
import ESelectCidade from '@/components/ESelectCidade'
import relatorioService from '@/services/relatorio'
import store from '@/store'

export default {
  name: 'profissionais',
  components: {
    ESelectCidade
  },
  data () {
    return {
      profissional: {},
      itemList: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      menuDateNascimento: false,
      resultado: {},
      itemSenha: [
        'N',
        'S'
      ]
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      if (id === undefined) {
        this.profissional.id = ''
        this.profissional.ativo = 'S'
        this.modo = 'I'
        return
      }
      this.modo = 'A'
      this.profissional = await profissionalService.getById(id)
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    computedDateFormattedNascimento () {
      return formatDateToBr(this.profissional.nascimento)
    }
  },
  methods: {
    async onDataSelect () {
      try {
        if (this.profissional.nascimento.length === 10) {
          var ret = validateDate(this.profissional.nascimento)
          if (ret === false) {
            showError('Data de nascimento inválida')
            this.profissional.nascimento = ''
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        // this.ultimoLancamentoLoadingIsVisible = false
      }
    },
    async imprimirCartao () {
      if (this.profissional.id === '') {
        showError('Profissional não selecionado')
      } else {
        this.imprimirCartao1()
      }
    },
    async imprimirCartao1 () {
      try {
        const result = await relatorioService.reportcartao('profissional', store.nome, this.profissional.id)
        if (result[0].erro === 'S') {
          showError('Atenção: ' + result[0].path)
        } else {
          window.open(result[0].path)
        }
      } catch (error) {
        showError(error)
      }
    },
    async salvar () {
      try {
        // this.loading = true
        if (this.profissional.nascimento !== undefined && this.profissional.nascimento !== '' && this.profissional.nascimento !== null) {
          var ret = validateDate(this.profissional.nascimento)
          if (ret === false) {
            showError('Data de nascimento inválida')
            this.profissional.nascimento = ''
            return
          }
        }
        if (this.modo === 'A') {
          this.resultado = await profissionalService.savePut(this.profissional)
        } else {
          this.resultado = await profissionalService.savePost(this.profissional)
        }
        if (this.modo === 'I') { // NOVO ASSOCIADO
          if (this.resultado !== undefined && this.resultado.id !== undefined) {
            this.profissional.id = ''
            this.profissional.cpf = ''
            // this.profissional.nascimento = ''
            this.profissional.ativo = 'S'
            this.profissional.nome = ''
            this.profissional.endereco = ''
            this.profissional.numero = ''
            this.profissional.bairro = ''
            this.profissional.localidade = ''
            // this.profissional.fk_cidade = ''
            this.profissional.cep = ''
            this.profissional.uf = ''
            this.profissional.celular = ''
            this.profissional.fixo = ''
            this.modo = 'I'
          }
        } else { // Cliente EXISTENTE
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    },
    carretaAtividade () {
    },
    onSelectCidade (item) {
      this.profissional.uf = item.uf
      this.profissional.fk_cidade = item.codigo
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
</style>
